import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { supabase } from "../../lib/supabase";

export default function Dashboard() {
  const { admin } = useOutletContext();
  const [stats, setStats] = useState({
    empresasPendentes: 0,
    empresasAprovadas: 0,
    avaliacoesPendentes: 0,
    avaliacoesAprovadas: 0,
    vagasPendentes: 0,
    vagasAprovadas: 0,
    mulheresTotal: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Empresas pendentes
        const { count: empresasPendentes } = await supabase
          .from("empresas")
          .select("*", { count: "exact", head: true })
          .eq("status", "pendente");

        // Empresas aprovadas
        const { count: empresasAprovadas } = await supabase
          .from("empresas")
          .select("*", { count: "exact", head: true })
          .eq("status", "aprovado");

        // Avaliacoes pendentes
        const { count: avaliacoesPendentes } = await supabase
          .from("avaliacoes")
          .select("*", { count: "exact", head: true })
          .eq("status", "pendente");

        // Avaliacoes aprovadas
        const { count: avaliacoesAprovadas } = await supabase
          .from("avaliacoes")
          .select("*", { count: "exact", head: true })
          .eq("status", "aprovado");

        // Vagas pendentes
        const { count: vagasPendentes } = await supabase
          .from("vagas")
          .select("*", { count: "exact", head: true })
          .eq("status", "pendente");

        // Vagas aprovadas
        const { count: vagasAprovadas } = await supabase
          .from("vagas")
          .select("*", { count: "exact", head: true })
          .eq("status", "aprovado");

        // Total de mulheres
        const { count: mulheresTotal } = await supabase
          .from("mulheres")
          .select("*", { count: "exact", head: true });

        setStats({
          empresasPendentes: empresasPendentes || 0,
          empresasAprovadas: empresasAprovadas || 0,
          avaliacoesPendentes: avaliacoesPendentes || 0,
          avaliacoesAprovadas: avaliacoesAprovadas || 0,
          vagasPendentes: vagasPendentes || 0,
          vagasAprovadas: vagasAprovadas || 0,
          mulheresTotal: mulheresTotal || 0
        });
      } catch (error) {
        console.error("Erro ao buscar estatisticas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const StatCard = ({ title, value, pending, color }) => (
    <div style={{
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "1.5rem",
      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
    }}>
      <h3 style={{ fontSize: "0.875rem", color: "#6b7280", marginBottom: "0.5rem" }}>
        {title}
      </h3>
      <p style={{ fontSize: "2rem", fontWeight: "700", color: color || "#1f2937" }}>
        {value}
      </p>
      {pending !== undefined && pending > 0 && (
        <p style={{ fontSize: "0.75rem", color: "#f59e0b", marginTop: "0.5rem" }}>
          {pending} pendente(s)
        </p>
      )}
    </div>
  );

  if (loading) {
    return <p>Carregando estatisticas...</p>;
  }

  return (
    <div>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "700", marginBottom: "0.5rem" }}>
        Dashboard
      </h1>
      <p style={{ color: "#6b7280", marginBottom: "2rem" }}>
        Bem-vinda, {admin?.nome || admin?.email}
      </p>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "1.5rem"
      }}>
        <StatCard 
          title="Empresas Aprovadas" 
          value={stats.empresasAprovadas}
          pending={stats.empresasPendentes}
          color="#059669"
        />
        <StatCard 
          title="Avaliacoes Aprovadas" 
          value={stats.avaliacoesAprovadas}
          pending={stats.avaliacoesPendentes}
          color="#3b82f6"
        />
        <StatCard 
          title="Vagas Ativas" 
          value={stats.vagasAprovadas}
          pending={stats.vagasPendentes}
          color="#8b5cf6"
        />
        <StatCard 
          title="Mulheres Cadastradas" 
          value={stats.mulheresTotal}
          color="#ec4899"
        />
      </div>

      {/* Alertas de pendencias */}
      {(stats.empresasPendentes > 0 || stats.avaliacoesPendentes > 0 || stats.vagasPendentes > 0) && (
        <div style={{
          marginTop: "2rem",
          backgroundColor: "#fef3c7",
          border: "1px solid #f59e0b",
          borderRadius: "8px",
          padding: "1rem"
        }}>
          <h3 style={{ fontWeight: "600", color: "#92400e", marginBottom: "0.5rem" }}>
            Itens aguardando aprovacao
          </h3>
          <ul style={{ color: "#92400e", fontSize: "0.875rem", paddingLeft: "1.25rem" }}>
            {stats.empresasPendentes > 0 && (
              <li>{stats.empresasPendentes} empresa(s) pendente(s)</li>
            )}
            {stats.avaliacoesPendentes > 0 && (
              <li>{stats.avaliacoesPendentes} avaliacao(oes) pendente(s)</li>
            )}
            {stats.vagasPendentes > 0 && (
              <li>{stats.vagasPendentes} vaga(s) pendente(s)</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
